export const SOLD_SUBSCRIPTIONS_STATUS_FILTER_OPTIONS = {
    CLOSED: 'closed',
    OPEN: 'open',
    PAUSED: 'paused',
    PAID: 'paid',
    AUTOMATIC: 'automatic',
    MANUAL: 'manual',
};
